export default __webpack_public_path__ + "assets/models/1f6c56e3fd78b8c47b35b9d00e6fa91b.glb";